import {
  type AccountInfo,
  Button,
  Flex,
  Layout,
  type SiderProps,
  theme,
} from '@/components';
import { Z_INDEX_GLOBAL_SIDEBAR } from '@/utils';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import type { ComponentProps, FC, ReactNode } from 'react';
import { Account } from './Account';
import { SidebarMenu } from './SidebarMenu';

type Props = {
  collapsed: SiderProps['collapsed'];
  onCollapse: SiderProps['onCollapse'];
  logo: ReactNode;
} & ComponentProps<typeof AccountInfo> &
  ComponentProps<typeof SidebarMenu>;

export const SidebarContent: FC<Props> = ({
  collapsed,
  onCollapse,
  accountName,
  iconUrl,
  organizationName,
  selectedKey,
  topMenu,
  bottomMenu,
  logo,
  secondLastLoginTime,
}) => {
  const { token } = theme.useToken();
  const borderStyle = `1px solid ${token.colorFill}`;

  return (
    <Layout.Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      theme="light"
      style={{
        position: 'fixed',
        left: 0,
        top: 0,
        bottom: 0,
        zIndex: Z_INDEX_GLOBAL_SIDEBAR,
        borderRight: borderStyle,
      }}
      trigger={
        <Flex
          style={{
            padding: '8px 16px',
            borderTop: borderStyle,
            borderRight: borderStyle,
            display: 'flex',
            backgroundColor: 'transparent',
            height: 64,
          }}
          {...(collapsed && { justify: 'center' })}
        >
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            style={{
              fontSize: 16,
            }}
          />
        </Flex>
      }
    >
      <div
        style={{
          height: 'calc(100vh - 64px)',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        {logo}
        <Account
          accountName={accountName}
          organizationName={organizationName}
          iconUrl={iconUrl}
          collapsed={collapsed}
        />
        <SidebarMenu
          selectedKey={selectedKey}
          collapsed={collapsed}
          topMenu={topMenu}
          bottomMenu={bottomMenu}
          secondLastLoginTime={secondLastLoginTime}
        />
      </div>
    </Layout.Sider>
  );
};
